module.exports = __webpack_public_path__ + "static/img/Element.48164f39.png";